class s extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M12.008 10.007a2.5 2.5 0 0 0-1.945.945L6.406 8.667a2.23 2.23 0 0 0 0-1.32l3.655-2.285a2.5 2.5 0 1 0-.555-1.555c.003.224.037.446.1.66L5.952 6.452a2.5 2.5 0 1 0 0 3.11l3.655 2.285a2.395 2.395 0 0 0-.1.66 2.5 2.5 0 1 0 2.5-2.5Zm0-8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-8 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm8 4.5a1.5 1.5 0 1 1 0-2.999 1.5 1.5 0 0 1 0 3Z"></path></svg>';
  }
}
const e = "pi-share";
customElements.get(e) || customElements.define(e, s);
export {
  s as default
};
